import { render } from "./index.vue?vue&type=template&id=17401560"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/add-products/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17401560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17401560', __exports__)) {
    console.log('reload')
    api.reload('17401560', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=17401560", () => {
    console.log('re-render')
    api.rerender('17401560', render)
  })

}


export default __exports__